import React from 'react'
import Link from 'gatsby-link'
import Nav from 'components/nav'
import Logo from 'components/logo'

const Header = ({ title }) => (
  <header id='header-main'>
    <Logo/>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js